import React from 'react'
import {
  Route,
  Redirect,
  IndexRoute,
  IndexRedirect,
} from 'react-router'
import init from './init'
import LogbookPage from './containers/LogbookPage'
import LogbookRebolt from './containers/LogbookRebolt'
import LogbookReboltReport from './containers/LogbookReboltReport'
import LogbookTest from './containers/LogbookTest'
import LogbookTestReport from './containers/LogbookTestReport'

function requireAuth(nextState, replace){
  // if(!window.store.getState().me.role){
  if(!window.store.getState().me.uid){
    location.href = location.origin
  }
}


const Routes = (
    <Route path="/" component={LogbookPage} onEnter={requireAuth}>
      <Route path="rebolt" component={LogbookRebolt} />
      <Route path="test" component={LogbookTest} />
      <Route path="rebolt-report" component={LogbookReboltReport} />
      <Route path="test-report" component={LogbookTestReport} />

      <IndexRedirect to="test-report" />
      <Redirect path="*" to="/" />
    </Route>
)

init(Routes)




/** WEBPACK FOOTER **
 ** ./src/app/logbook.js
 **/